if (!customElements.get('site-header')) {
  customElements.define('site-header', class SiteHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header-new');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      /* Mobile menu */
      let hamburger = this.querySelector('[data-mobile-menu-open]');
      let mobileMenu = this.querySelector('.mobile-menu');
      hamburger.addEventListener('click', function (evt) {
        evt.preventDefault();
        this.classList.toggle('open');
        mobileMenu.classList.toggle('open');
        if (document.querySelector('body').classList.contains('menu-open')) {
          document.querySelector('body').classList.remove('menu-open');
        } else {
          document.querySelector('body').classList.add('menu-open');
        }
      })

      // submenu shop
      let shopAsLink = this.querySelector('[data-mobile-shopsubmenu-open]');
      let shopAslinkParent = this.querySelector('[data-mobile-shop-list]');
      let shopAsSubmenu = this.querySelector('.as-shop-hidden-submenu');
      let leftArrow = this.querySelector('.as-left-arrow-mobile-menu');
      let rightArrow = this.querySelector('.as-right-arrow-mobile-menu');
      shopAsLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        shopAsSubmenu.classList.toggle('open');
        shopAslinkParent.classList.toggle('as-item-with-sumbenu');
        leftArrow.classList.toggle('as-no-display');
        rightArrow.classList.toggle('as-no-display');
      })

      // submenu learn
      let learnAsLink = this.querySelector('[data-mobile-learnsubmenu-open]');
      let learnAslinkParent = this.querySelector('[data-mobile-shop-list]');
      let learnAsSubmenu = this.querySelector('.as-learn-hidden-submenu');
      let leftArrowLearn = this.querySelector('.as-learn-left-arrow-mobile-menu');
      let rightArrowLearn = this.querySelector('.as-learn-right-arrow-mobile-menu');
      learnAsLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        learnAslinkParent.classList.toggle('as-item-with-sumbenu');
        learnAsSubmenu.classList.toggle('open');
        leftArrowLearn.classList.toggle('as-no-display');
        rightArrowLearn.classList.toggle('as-no-display');
        document.querySelectorAll('.as-hide-on-learn').forEach((menumobile) => {
          menumobile.classList.toggle('as-no-display');
        })
      })

      document.querySelectorAll('.shop-menu__block-link').forEach((menuLink) => {
        menuLink.addEventListener('click', function (evt) {
          //document.querySelector('.header__shop-menu').classList.remove('open');
        })
      })
      // ***This code was closing menu when clicking on a item, and we don't need this behaivor because we have submenu now ***//
      /*
            document.querySelectorAll('.mobile-menu__link').forEach((mobileLink) => {
              mobileLink.addEventListener('click', function (evt) {
                document.querySelector('body').classList.remove('menu-open');
                document.querySelector('[data-mobile-menu-open]').classList.remove('open');
                document.querySelector('.mobile-menu').classList.remove('open');
              })
            })*/

      /* Desktop menu */
      let shopLink = this.querySelector('[data-shop-link]');
      let shopMenuDropdown = this.querySelector('.header__shop-menu');
      shopLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        shopMenuDropdown.classList.toggle('open');
      })

      document.addEventListener('click', function (evt) {
        if (evt.target.closest('.header__shop-menu') == null && evt.target.closest('[data-shop-link]') == null) {
          shopMenuDropdown.classList.remove('open');
        } else if (evt.target.closest('.shop-menu__block') != null) {
          shopMenuDropdown.classList.remove('open');
        }
      })

      // learn menu
      let learnLink = this.querySelector('[data-learn-link]');
      let learnMenuDropdown = this.querySelector('.header__learn-menu');
      learnLink.addEventListener('click', function (evt) {
        evt.preventDefault();
        learnMenuDropdown.classList.toggle('open');
      })

      document.addEventListener('click', function (evt) {
        if (evt.target.closest('.header__learn-menu') == null && evt.target.closest('[data-learn-link]') == null) {
          learnMenuDropdown.classList.remove('open');
        } else if (evt.target.closest('.shop-menu__block') != null) {
          learnMenuDropdown.classList.remove('open');
        }
      })
    }


    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      /*this.closeMenuDisclosure();
      this.closeSearchModal();*/
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

  })
}
